import axios from "axios";
import { setHeader } from "./Headers";
import { Getauth } from "./Auth";
import { Url } from "./Constants";
import { useNavigate } from "react-router-dom";




export async function CartUpdate (){

    console.log("start")
        try {
            const user = await axios.get(`${Url}/buyer/get_profile`, setHeader());
            // console.log(user)
            if (user.data.response_code===200) {
                const data = localStorage.getItem("cart");
                if (data) {
                    const newData = JSON.parse(data);
                    const cartItems = await Promise.all(newData.map(async (e) => { 
                        try {
                          const result = await axios.post(`${Url}/buyer/carts/add_to_cart?product_variant_id=${e.product_variant_id}&quantity=${e.quantity}`, {}, setHeader());
                        //   const a = {...result,product_variant_id:e.product_variant_id}
                        } catch (error) {
                          console.error(error)
                          return error
                        }
                      }));
                    try {
                        const result = await axios.get(`${Url}/buyer/carts?page=1`, setHeader());
                        const cartIds = result.data.response_data.carts
                        // console.log(cartIds)
                        if(result.data.response_code===200){
                            localStorage.setItem("cart", JSON.stringify(cartIds));
                        }
                        else{
                            localStorage.setItem("cart",[])
                        }

                    } catch (error) {
                        console.error('Error updating cart:', error);
                    }
                    return true
                } else {
                    const result = await axios.get(`${Url}/buyer/carts?page=1`, setHeader());
                    // console.log(result)
                        if(result.data.response_code===200){
                            const cartIds = result.data.response_data.carts
                            localStorage.setItem("cart", JSON.stringify(cartIds));
                        }
                        else{
                            localStorage.setItem("cart",[])
                        }
                    return true
                }
            }else{
                return true
            }
        } catch (error) {
            console.error('Error checking user authentication:', error);
        }
        return (true)
    
};